import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $ } from "./dom";
import { hideOverlay, isOverlayOpen, runTeaser } from "@jpj/game-shell";
import { state } from "./game/state";
import { LEVELS } from "./game/levels";
import { key } from "./game/geometry";
import { buildGrid, buildTrees, layout as layoutBoard } from "./game/board";
import {
  buildDots, goNext, goPrev, layout, recompute, resetLevel,
  restartGame, startGame, updateNav,
} from "./game/flow";
import { initInteraction } from "./game/interaction";
import { skipCompare, nextCompare, relayoutReveal } from "./reveal/reveal";
import { openLearn, closeLearn, stepLearn } from "./reveal/learn";

/* ---------- Nav + controls ---------- */
$("prevBtn").addEventListener("click", goPrev);
$("nextBtn").addEventListener("click", goNext);
$("resetBtn").addEventListener("click", resetLevel);

/* ---------- Reveal / explainer buttons (always present in the DOM) ---------- */
$("cmpSkip").addEventListener("click", skipCompare);
$("cmpNext").addEventListener("click", nextCompare);
$("learnBtn").addEventListener("click", openLearn);
$("again2").addEventListener("click", () => {
  hideOverlay("solverOverlay");
  restartGame();
});
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));

/* ---------- Intro ---------- */
const beginGame = (): void => {
  hideOverlay("introOverlay");
  startGame();
};
$("beginBtn").addEventListener("click", beginGame);

/* ---------- Resize ---------- */
window.addEventListener("resize", () => {
  if (state.phase === "play") layout();
  if (isOverlayOpen("solverOverlay")) relayoutReveal();
});

/* ---------- Init ---------- */
// the title scene stays up until the player picks "How to Play" or "Start"
runTeaser({ onStart: beginGame });
initInteraction();
buildDots();
// preload the first level behind the intro so it looks ready
state.idx = 0;
state.treeSet = new Set(LEVELS[0].trees.map(([r, c]) => key(r, c)));
state.rockSet = new Set(LEVELS[0].rocks.map(([r, c]) => key(r, c)));
buildGrid();
buildTrees();
layoutBoard();
recompute();
updateNav();
// re-run layout once the custom fonts settle (changes available width)
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { layoutBoard(); recompute(); });
